export default function GameTitle(props: any) {
  return (
    <svg
      id="prefix__Capa_1"
      data-name="Capa 1"
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 400 156.41"
      {...props}
    >
      <defs>
        <style>{'.prefix__cls-1{fill:#f7d354}'}</style>
      </defs>
      <path
        className="prefix__cls-1"
        d="M49.67 91.79L34 40.81v51H0V.29h48.36L63.39 50 78.43.29h48.36v91.5h-34v-51l-15.68 51zM176.47 91.79h-34V.29h34zM226.14 65.65h35.29v26.14h-69.28V.29h34zM311.11 65.65h39.21v26.14h-73.2V.29h73.2v26.15h-39.21V33h39.21v26.11h-39.21zM400 91.79h-34V.29h34zM51.53 141.19h20.24v13.5H34v-47.25h37.77v13.5H51.53v3.37h20.24v13.5H51.53zM95.4 141.19h18.22v13.5H77.85v-47.25H95.4zM143.31 107.44h17.55v26.32c0 14.17-8.77 22.94-18.89 22.94-8.77 0-13.5-4-13.5-4l4.72-14.17a9.34 9.34 0 004.72 1.35c3 0 5.4-2.36 5.4-6.07zM195.28 132.75v-25.31h17.55v25.31c0 13.5-9.45 22.95-22.95 22.95s-22.94-9.45-22.94-22.95v-25.31h17.55v25.31c0 3.71 2.36 6.07 5.4 6.07s5.39-2.36 5.39-6.07zM236.44 141.19h20.25v13.5H218.9v-47.25h37.79v13.5h-20.25v3.37h20.25v13.5h-20.25zM291.11 139.16v-8.1h16.2v16.54s-6.07 8.1-19.57 8.1c-14.17 0-25-10.8-25-24.63s10.8-24.63 25-24.63c12.82 0 18.9 7.42 18.9 7.42l-8.1 12.82s-4-3.71-8.77-3.71a8.1 8.1 0 000 16.2zM339.7 155.7c-15.52 0-26.32-10.8-26.32-24.63s10.8-24.63 26.32-24.63 26.3 10.79 26.3 24.62-10.78 24.64-26.3 24.64zm0-32.73c-4 0-7.42 3.37-7.42 8.1s3.37 8.1 7.42 8.1 7.42-3.37 7.42-8.1-3.37-8.07-7.42-8.07z"
        transform="translate(0 -.29)"
      />
    </svg>
  );
}
